import { Modal } from 'antd';
import MarkdownWithToc from '@/components/MarkdownWithToc';
import API_DOC_CONTENT from '@/assets/BSP_API_GUIDE.md?raw';

interface InternalApiDocModalProps {
  open: boolean;
  onClose: () => void;
}

const InternalApiDocModal = ({ open, onClose }: InternalApiDocModalProps) => {
  return (
    <Modal
      title="BSP API 使用指南"
      open={open}
      onCancel={onClose}
      footer={null}
      width={1100}
      style={{ top: 20 }}
      styles={{ body: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' } }}
    >
      <MarkdownWithToc content={API_DOC_CONTENT} />
    </Modal>
  );
};

export default InternalApiDocModal;
